import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { BlFrontendButtonComponent } from '@app/core/wrappers/bl-frontend-button.component';
import { DialogForm, DialogResult } from '@app/shared/components/form-dialog-base/form-dialog-base.component';
import { TranslocoModule } from '@jsverse/transloco';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { getTranslationProvider } from 'src/app/core/i18n/getTranslationProvider';
import { TranslatableFormDialogBaseComponent } from 'src/app/core/i18n/translatable-form-dialog-base.component';
import { BlFrontendTextInputComponent } from 'src/app/core/wrappers/bl-frontend-text-input.component';

interface Result extends DialogResult {
  amlId: string;
}

interface Form extends DialogForm<unknown> {
  amlId: FormControl<string>;
}

const TRANSLATION_SCOPE = 'inputExistingAmlIdDialogComponent';

@Component({
  template: `
    <ng-container *transloco="let t; prefix: scope">
      <form [formGroup]="form" (ngSubmit)="onSubmit()" pFocusTrap>
        <p class="mb-0">{{ t('enterAmlId') }}</p>
        <p class="text-sm text-bl-grey-500">{{ t('youFindItAtDueCompliance') }}</p>
        <div>
          <bl-frontend-text-input formControlName="amlId" class="w-full"></bl-frontend-text-input>
        </div>
        <div class="flex flex-row w-full justify-end mt-8">
          <bl-frontend-button
            type="button"
            variant="secondary"
            (onclick)="close({ amlId: null })"
            [text]="'shared.cancel' | transloco"></bl-frontend-button>
          <bl-frontend-button
            type="submit"
            variant="primary"
            class="ml-2"
            [disabled]="form.invalid"
            [text]="'shared.save' | transloco"></bl-frontend-button>
        </div>
      </form>
    </ng-container>
  `,
  standalone: true,
  providers: [getTranslationProvider(TRANSLATION_SCOPE)],
  imports: [
    InputTextModule,
    ReactiveFormsModule,
    BlFrontendButtonComponent,
    TranslocoModule,
    BlFrontendTextInputComponent,
  ],
})
export class InputExistingAmlIdDialogComponent extends TranslatableFormDialogBaseComponent<null, Result, Form> {
  protected override onInitialized = () => {
    this.form = this.builder.group({
      amlId: new FormControl('', [Validators.required]),
    });
  };

  protected static override getTranslationScope(): string {
    return TRANSLATION_SCOPE;
  }

  protected static override getDialogConfig(translation: Record<string, string>): Omit<DynamicDialogConfig, 'data'> {
    return {
      header: translation.connectExtistingAmlCheck,
      width: '350px',
      height: 'auto',
      modal: true,
    };
  }

  onSubmit() {
    const { amlId } = this.form.value;
    this.close({ amlId });
  }
}
